import { DrawableChartConfigDto, PitchTypeUsageChartDataDto } from 'types/CodegenReportTypes';

import { ChartProps } from 'utilities/chartIdToComponent';

import useReportStore from 'hooks/PracticeReport/PitcherSingle/reportStore';
import PitchTypeUsageChart from 'components/Charts/PitchTypeUsageChart/PitchTypeUsageChart';

const PracticePitcherSingleSessionPitchTypeUsageChart = (props: ChartProps<PitchTypeUsageChartDataDto, DrawableChartConfigDto>) => {
  const { selectedConfgValues } = useReportStore();

  return <PitchTypeUsageChart {...props} pitchGrouping={selectedConfgValues.pitchGrouping} />;
};

export default PracticePitcherSingleSessionPitchTypeUsageChart;
